import _ from 'lodash'
import moment from 'moment'

export const toastModule = {
  namespaced: true,
  state: () => ({
    toasts: []
  }),
  mutations: {
    error(state, payload) {
      if (_.map(state.toasts, 'message').indexOf(payload.message) == -1) {
        state.toasts.push({
          message: payload.message,
          type: 'error',
          height: payload.height,
          persistTime: payload.persistTime,
          id: payload.id || `${moment().unix()}-${parseInt(Math.random() * 1000000)}`
        })
      }
    },

    warning(state, payload) {
      if (_.map(state.toasts, 'message').indexOf(payload.message) == -1) {
        state.toasts.push({
          message: payload.message,
          type: 'warning',
          height: payload.height,
          persistTime: payload.persistTime,
          id: payload.id || `${moment().unix()}-${parseInt(Math.random() * 1000000)}`
        })
      }
    },

    success(state, payload) {
      if (_.map(state.toasts, 'message').indexOf(payload.message) == -1) {
        state.toasts.push({
          message: payload.message,
          type: 'success',
          height: payload.height,
          errors: payload.errors ? payload.errors : null,
          persistTime: payload.persistTime,
          id: payload.id || `${moment().unix()}-${parseInt(Math.random() * 1000000)}`
        })
      }
    },

    destroyToast(state, id) {
      if (id) {
        let i = _.findIndex(state.toasts, (t) => {
          return t.id == id
        })
        if (i || i == 0) {
          state.toasts.splice(i, 1)
        }
      }
    },

    clearToasts(state) {
      state.toasts = []
    }
  },
  getters: {
    getToasts(state) {
      return state.toasts
    }
  }
}
